import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox, ControlLabel } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: '',
            horFrom: '',
            hourTo: '',
            source: null,
            affid: null,
            usedAffid: null,
            country: null,
            groupBy: {},
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentWillUpdate(nextProps) {
        if(this.props.type !== nextProps.type) {
            this.setState({ day: '', hourFrom: '', hourTo: '', affid: null, groupBy: {} })
        }
    }

    handleFormSubmit() {
        const isValid = this.validateForm();
        const filters = { ...this.state };
        filters.groupBy = Object.keys(filters.groupBy);

        if(isValid) this.props.onSubmit(filters);
    }

    handleGroupByChange({ target }) {
        const groupBy = { ...this.state.groupBy };
        const { name, checked } = target;

        if(checked) groupBy[name] = 1;
        else delete groupBy[name];

        this.setState({ groupBy });
    }

    validateForm() {
        const { day } = this.state;

        let alert = null;

        if(!day ) alert = 'Please set Day';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    getDateInputs() {
        let inputs = [];

        inputs.push(<Col lg={4}>
            <FieldGroup
                type="date"
                name="day"
                label="Day:"
                onChange={this.handleFieldChange}
                value={this.state.day}
            />
        </Col>);

        if(this.props.type === 'hourly') {
            inputs.push(<Col lg={4}>
                <FieldGroup
                    type="number"
                    name="hourFrom"
                    label="Hour From:"
                    min={0}
                    max={23}
                    onChange={this.handleFieldChange}
                    value={this.state.hourFrom}
                />
            </Col>);
            inputs.push(<Col lg={4}>
                <FieldGroup
                    type="number"
                    name="hourTo"
                    label="Hour To:"
                    min={0}
                    max={23}
                    onChange={this.handleFieldChange}
                    value={this.state.hourTo}
                />
            </Col>)
        }

        return inputs;
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>
                        <Checkbox onChange={this.handleGroupByChange} name="date" checked={this.state.groupBy.date || false}>Date</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="source" checked={this.state.groupBy.source || false}>Source</Checkbox>
                        { this.props.type === 'hourly' ? <Checkbox onChange={this.handleGroupByChange} name="affid" checked={this.state.groupBy.affid || false}>Affid</Checkbox> : null }
                        <Checkbox onChange={this.handleGroupByChange} name="usedAffid" checked={this.state.groupBy.usedAffid || false}>Used Affid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="country" checked={this.state.groupBy.country || false}>Country</Checkbox>
                    </Col>
                    <Col lg={8}>
                        <Row>
                            {this.getDateInputs()}
                        </Row>
                    </Col>
                    { this.props.type === 'hourly' ?
                        <Col lg={4}>
                            <SelectWrap
                                values={this.props.affids}
                                label="Affid:"
                                name="affid"
                                onChange={this.handleFieldChange}
                                value={this.state.affid}
                                multi
                            />
                        </Col>
                        : null
                    }
                </Row>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.usedAffids}
                            label="Used Affid:"
                            name="usedAffid"
                            onChange={this.handleFieldChange}
                            value={this.state.usedAffid}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.sources}
                            label="Sources:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit()}>Load</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderCtrHourly/components/Form/index.js